module.exports = __webpack_public_path__ + "static/media/armor-logo.4404ddc0.svg";